<template>
    <div>
        <text-decorator bold :color="Color.gray400">
            <slot name="label" />
            <slot />
        </text-decorator>

        <div class="color-input">
            <label class="color-input__preview">
                <input
                    v-model="internalValue"
                    type="color"
                />

                <span :style="previewStyle">
                    <span class="svg-wrapper">
                        <svg-icon :icon="IconPalette" />
                    </span>
                </span>
            </label>

            <input-group v-model="internalValue">
                <template #input>
                    <text-input />
                </template>
            </input-group>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, ref, type StyleValue, watch } from 'vue';
    import { Color } from '@keyvue/one-ui';

    import IconPalette from '@keyvue/one-material-icons/icons/palette.svg?component';

    const props = defineProps<{ modelValue: string | null }>();

    const internalValue = ref(props.modelValue);
    const emit = defineEmits(['update:modelValue']);

    const previewStyle = computed(() => ({
        width: '38px',
        height: '38px',
        backgroundColor: internalValue.value,
    } as StyleValue));

    watch(
        () => props.modelValue,
        (value) => {
            internalValue.value = value;
        },
    );

    watch(
        () => internalValue.value,
        (value) => {
            emit('update:modelValue', value);
        },
    );
</script>

<style scoped lang="scss">
.color-input {
    display: flex;
    align-items: flex-end;
    position: relative;

    &__preview {
        input[type='color'] {
            position: absolute;
            bottom: 0;
            width: 0;
            height: 0;
            float: left;
            opacity: 0;
        }

        > span {
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: size(xs);
            margin-right: size(xs);
            border: 1px solid color(gray-300);
        }

        .svg-wrapper {
            color: white;
            mix-blend-mode: hard-light;
        }
    }
}
</style>
